<template>
  <div class="Info">
    <div class="title">{{title}}</div>
    <div class="panel">
      <div class="notice">
        <div class="item" v-for="n in notice">{{n}}</div>
      </div>
      <div class="button">
        <div v-if="user">
          <my_button v-if="user.enrolled" :value="'开始比赛'" :inputStyle="buttonStyle" @click.native="start"></my_button>
          <my_button v-else :value="'开始报名'" :inputStyle="buttonStyle" @click.native="enroll"></my_button>
        </div>
        <div class="tips fs14" :class="{user: user, success: tips}">{{tip}}</div>
      </div>
    </div>
  </div>
</template>

<script>
 import MyButton from '@/components/Button.vue'
 export default {
   name: 'EnrollInfo',
   data () {
     return {
       tips: false,
       tip: '请先登录你的账号',
     }
   },
   methods: {
     enroll(){
       /* if(!this.user.coco_id){
        *   this.tips=true;
        *   this.tip = "请先选择绑定账号";
        *   return;
        * } */
       let form = this.$store.state.input.enroll;
       let data = new FormData();
       data.set('area_id', form.area.id);
       data.set('city', form.area.city);
       data.set('age', 5);
       data.set('group', form.group+1);
       data.set('language', form.lang)
       data.set('organization', form.organization)
       this.$http.post('/api/user/enroll', data)
           .then(res => {
             this.tip = '报名成功'
             this.tips=true;
             /* this.$store.commit("SUCCESS_ENROLLED");*/
             window.location.reload();
           })
     },
     start(){
       if(this.user){
         if(this.user.enrolled)
           {
             window.open(this.$store.state.gamelink+this.$store.state.auth.token.token)
           }
         else
           {
             this.$router.push({name: 'enroll'})
           }
       }
       else
         {
           this.$router.push({name:'account', params:{type:'login'}})
         }


     }
   },
   computed: {
     title() {
       return '报名须知'
     },
     notice () {
       return this.$store.state.enroll.notice;
     },
     buttonStyle () {
       return {
         'background-color': '#F8E900',
         'font-size': '0.9375vw',
         'color': '#241171',
         'height': '2.6vw',
         'border-radius': '3px'
       }
     },
         user() {
       return this.$store.state.auth.user
     },
   },
   components:{
     my_button: MyButton
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   width: 62.5vw;
   box-sizing: border-box;
   border-radius: 1vw;

   background: linear-gradient(to right, #3F3AF5, #3714F5);
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: space-between;
 }
 .title{
   color: white;
   font-size: 1.875vw;
   line-height: 6.85vw;
   display: flex;
   align-items:center;
   justify-content: center;

   background-image: url(~@/assets/image/enroll/bg-area.png);
   background-size: 62.5vw;
   width: 100%;
 }
 .panel{
   width: 100%;
   display: flex;
   align-items: center;
   justify-content:space-between;
   flex-direction: column;
 }

 .notice{
   color: white;
   line-height: 1.5625vw;
   width: 88%;
   margin-top: 2vw;
 }
 .button{
   width: 7.6vw;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   position: relative;
   margin: 2vw 0;
 }

 .item{
   white-space: pre-line;
 }
 .tips{
   color: #FF3D2E;
   font-size: 0.9375vw;
   display: flex;
   background-image: url(~@/assets/image/enroll/bg-tips.png);
   background-size: 10.1vw;
   position: absolute;
   top: -2.2vw;
   height: 1.92vw;
   width: 9.1vw;
   align-items:center;
   justify-content:center;
 }
 .tips.user{
   opacity: 0;
 }
 .tips.success{
   opacity: 1 !important;
   color: var(--blue);
 }
</style>
